import { render } from "./DialogNewDisitributionCreateWait.vue?vue&type=template&id=298a0e34"
import script from "./DialogNewDisitributionCreateWait.vue?vue&type=script&lang=js"
export * from "./DialogNewDisitributionCreateWait.vue?vue&type=script&lang=js"

import "./DialogNewDisitributionCreateWait.vue?vue&type=style&index=0&id=298a0e34&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__